import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Container, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../../redux/slice/authSlice/UserSlice.js";
import {
  profile,
  // dashboard,
  insta,
  facebook,
  snapchat,
  linked,
  logout,
  logo,
} from "../../../../assets/index.js";
import "./sidebar.css";

const Sidebar = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const token = localStorage.getItem("userToken");
    if (token) {
      await dispatch(logoutUser());
      console.log("User logged out successfully.");
      navigate("/login");
    } else {
      console.log("No token found, user is not logged in.");
      navigate("/login");
    }
  };

  return (
    <>
      <Nav.Link className="d-none d-md-flex flex-column p-3 bg-light sidebar-highlight background-dark bg-gradient">
        <Navbar.Brand as={Link} to="/" className="mb-3 fs-3">
          <div className="d-lg-flex align-items-center">
            <img
              src={logo}
              alt="Dashboard"
              className="side-img img-width-logo pe-1 dark-mode-img"
            />
          </div>
        </Navbar.Brand>

        <Nav className="flex-column ms-3">
          <Nav.Link
            as={Link}
            to="dashboard"
            className="mb-3 mt-3 fs-6 d-flex align-items-center w-75"
          >
            <div className="icon-circle">
              <i className="bi bi-house-door"></i>
            </div>
            <span className="ms-3 text-dark landing-text-white">Home</span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            className="mb-3 mt-3 fs-6 d-flex align-items-center w-75"
            to="analytics"
          >
            <div className="icon-circle">
              <i className="bi bi-graph-up-arrow"></i>
            </div>
            <span className="ms-3 text-dark landing-text-white">Analytics</span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            className="mb-3 mt-3 fs-6 d-flex align-items-center w-75"
            to="scheduling"
          >
            <div className="icon-circle">
              <i className="bi bi-table"></i>
            </div>
            <span className="ms-3 text-dark landing-text-white">
              Scheduling
            </span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            className="mb-3 mt-3 fs-6 d-flex align-items-center w-75"
            to="engagements"
          >
            <div className="icon-circle">
              <i className="bi bi-people"></i>
            </div>
            <span className="ms-3 text-dark landing-text-white">
              Engagement
            </span>
          </Nav.Link>
          <Dropdown className="mb-3 mt-3 fs-6 d-flex align-items-center w-75 custom-dropdown">
            <Dropdown.Toggle
              className="d-flex align-items-center text-decoration-none"
              variant="link"
              id="dropdown-basic"
            >
              <div className="icon-circle">
                <i className="bi bi-gear"></i>
              </div>
              <span className="ms-3 text-dark landing-text-white">
                Generate AI
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="p-1">
              <Dropdown.Item as={Link} to="ai">
                Generate Hashtags
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="caption">
                Generate Caption
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="content">
                Generate Content
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="nav-width border mt-3"></div>
          <div className="container photo-section ms-3 pb-5 mt-4">
            <div className="row">
              <div className="col-sm-4 d-flex justify-content-center align-items-center">
                <Link to="/insta">
                  <img src={insta} alt="Insta" className="circle-img" />
                </Link>
              </div>
              <div className="col-sm-4 d-flex justify-content-center align-items-center">
                <img src={snapchat} alt="Snapchat" className="circle-img" />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-4 d-flex justify-content-center align-items-center">
                <img src={linked} alt="LinkedIn" className="circle-img" />
              </div>
              <div className="col-sm-4 d-flex justify-content-center align-items-center">
                <img src={facebook} alt="Facebook" className="circle-img" />
              </div>
            </div>
          </div>
        </Nav>
      </Nav.Link>

      <Navbar bg="light" expand="md" className="d-md-none background-dark">
        <Container>
          <Navbar.Brand
            as={Link}
            to="/dashboard"
            className="ms-auto landing-text-white"
          >
            Dashboard
          </Navbar.Brand>
          <Navbar.Toggle onClick={handleShow} className="button-all" />
        </Container>
      </Navbar>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        className="background-dark bg-gradient"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link to="/" className="landing-text-white text-decoration-none">
              <div className="d-lg-flex align-items-center">
                <img
                  src={logo}
                  alt="Dashboard"
                  className="side-img img-width-logo pe-1 dark-mode-img"
                />
              </div>
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link
              as={Link}
              to="dashboard"
              className="mb-3 mt-3 fs-6 d-flex align-items-center"
              onClick={handleClose}
            >
              <div className="icon-circle">
                <i className="bi bi-house-door"></i>
              </div>
              <span className="ms-5 text-dark landing-text-white">Home</span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="mb-3 mt-3 fs-6 d-flex"
              to="analytics"
              onClick={handleClose}
            >
              <div className="icon-circle">
                <i className="bi bi-graph-up-arrow"></i>
              </div>
              <span className="ms-5 text-dark landing-text-white">
                Analytics
              </span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="mb-3 mt-3 fs-6 d-flex"
              to="scheduling"
              onClick={handleClose}
            >
              <div className="icon-circle">
                <i className="bi bi-table"></i>
              </div>
              <span className="ms-5 text-dark landing-text-white">
                Scheduling
              </span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="mb-3 mt-3 fs-6 d-flex"
              to="engagements"
              onClick={handleClose}
            >
              <div className="icon-circle">
                <i className="bi bi-people"></i>
              </div>
              <span className="ms-5 text-dark landing-text-white">
                Engagement
              </span>
            </Nav.Link>
            <Dropdown className="mb-3 mt-3 fs-6 d-flex a">
              <Dropdown.Toggle
                className="d-flex text-decoration-none"
                variant="link"
                id="dropdown-basic"
              >
                <div className="icon-circle">
                  <i className="bi bi-gear"></i>
                </div>
                <span className="ms-5 text-dark landing-text-white mt-2">
                  Generate AI
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="p-1">
                <Dropdown.Item as={Link} to="ai" onClick={handleClose}>
                  Generate Hashtags
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="caption" onClick={handleClose}>
                  Generate Caption
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="content" onClick={handleClose}>
                  Generate Content
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <div className="d-flex">
              <Nav.Link as={Link} to="/profile" onClick={handleClose}>
                <img src={profile} alt="Profile" className="img-width" />
                <span className="text-white ps-2">Profile</span>
              </Nav.Link>

              <Nav.Link className="me-5 header-image-sidebar d-lg-flex">
                <img
                  src={logout}
                  onClick={handleLogout}
                  alt="Logout"
                  className="img-width"
                />
                <span className="text-white ps-2">Logout</span>
              </Nav.Link>
            </div>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
